import { render, staticRenderFns } from "./imgCode.vue?vue&type=template&id=408b3bc2"
import script from "./imgCode.vue?vue&type=script&lang=js"
export * from "./imgCode.vue?vue&type=script&lang=js"
import style0 from "./imgCode.vue?vue&type=style&index=0&id=408b3bc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports